// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1Ts79","col":"styles_col__1TpXp"};